// 
// > Caution: adding .rwd-desktop CSS class for limiting processing to an 992px min window size

var fn_sticky = function () {
  var header = $('.rwd-desktop .nav__wrapper')

  $(window).scroll(function () {
    scrollPos = $(window).scrollTop()

    if (scrollPos > 100) {
      header.addClass('is-sticky')
    }else {
      header.removeClass('is-sticky')
    }
  })
}
